/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


/**
* An Identity Provider (IDP) configuration.
*/
export class Idp {
  /**
  * System-generated unique identifier for the IDP.
  */
  'id': string;
  /**
  * The name of the identity provider.
  */
  'providerName': string;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "id",
      "baseName": "id",
      "type": "string",
      "format": "uuid"
    },
    {
      "name": "providerName",
      "baseName": "providerName",
      "type": "string",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return Idp.attributeTypeMap;
  }

  public constructor() {
  }
}

